import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { _BudgetList, _CreateCashReimbursement } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { YearSelector } from "../../../../../../core/shared/inputs/YearSelector";
import { _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { CashDeskAccountSelector } from "../../../CashDeskAccount/CashDeskAccountSelector";
import { CDPCatalog } from "../../../CashDeskAccount/CashDeskAccountCDP/CDPCatalog/CDPCatalog";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { DocumentViewer } from "../../../../../theme/Component/DocumentViewer";
import { CashRequestBudget } from "./CashRequestBudget/CashRequestBudget";



export const BudgetListForRefund = () => {

    const BudgetList = useDataBean(_BudgetList);
    const createCash = useDataBean(_CreateCashReimbursement);
    const single = Singleton.getInstance();
    const [docs, setDocs] = useState<any>([]);
    const [Year, setYear] = useState<any>(_single.getCurrenYear());
    const [Year1, setYear1] = useState<any>(_single.getCurrenYear());
    const [cashDesk, setcashDesk] = useState<any>(null);
    const [cdpcatalog, setcdpcatalog] = useState<any>(null);
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    // const [modalcajamenor, setModalcajamenor] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalconsultar, setModalconsultar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalviewdoc, setModalviewdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });


    const getLista = () => {

        BudgetList.instance.getBudgetListForRefund(Year, cashDesk, cdpcatalog, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    console.log(resp)
                }
            }
        )

    }
    const crear = () => {
        setModal({ ...modal, "view": true });

    }


    const createCashReimbursement = () => {


        createCash.instance.createCashReimbursement(Year, cashDesk, createCash.bean.AccountantDate, cdpcatalog, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                    setModal({ ...modal, "view": false });
                    setModalviewdoc({ ...modalviewdoc, "view": true });
                    toast.success(resp.MsgList)
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const create = () => {
        BudgetList.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        BudgetList.deleteItemVoid(BudgetList.bean).then(
            (resp: any) => {

                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        BudgetList.update().then(
            (resp: any) => {

                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'Habilitado para Reembolso', property: 'Apply', visible: true },
        { title: 'Nombre de Rubro', property: 'BudgetIDStr', visible: true },
        { title: 'Valor de Rubro Pendiente de Reembolso', property: 'BudgetValue', visible: true },
        { title: 'Valor Disponible en Documento Presupuestal Seleccionado', property: 'LeftValue', visible: true },
        { title: 'Valor a Reembolsar', property: 'Value', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Consultar Valores Reembolsados', icono: 'ri-book-read-fill', visible: single.canDelete(), evento: () => { setModalconsultar({ ...modalconsultar, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Consultar Valores Pendientes de Reembolso ">
            <div className="row">
                <div className="col-md-4">
                    <YearSelector tittle="Año" value={Year} onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-4">
                    <CashDeskAccountSelector id={cashDesk} onchange={(e) => { setcashDesk(e) }} />
                </div>
                {cashDesk && <>
                    <>
                        <div className="row">
                            <div className="col-md-4">
                                <YearSelector tittle="Año Presupuestal" value={Year1} onChange={(e) => { setYear1(e) }} />
                            </div>
                            <div className="col-md-4">
                                <CDPCatalog year={Year1} idCashDeskAccount={cashDesk} idSelector={cdpcatalog} onChange={(e) => { setcdpcatalog(e) }} />
                            </div>
                        </div>
                    </>
                </>}
                {Year && <>

                    <div className="col-md-4 mt-4 p-2">
                        <BasicButton icon='ri-search-line' eventClick={() => { getLista() }} >Buscar</BasicButton>
                    </div>
                    <div className="col-md-6 mt-4 p-2">
                        <BasicButton icon='ri-send-plane-2-fill' eventClick={() => { crear() }} >Generar Reembolso de Caja Menor</BasicButton>
                    </div>
                </>}

                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={BudgetList.setBean} listButtons={listaBotones()}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={createCashReimbursement}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Generar Reembolso de Caja Menor</label>
                                <InputDate notDate label="Fecha" name="AccountantDate" value={createCash.bean.AccountantDate} setDate={(e) => { createCash.setBean({ ...createCash.bean, "AccountantDate": e }) }} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalconsultar} updateModal={setModalconsultar}>
                        <div className="row">
                            <div className="col-md-12">
                                <CashRequestBudget Year={BudgetList.bean.Year} IDCashDeskAccount={BudgetList.bean.IDCashDeskAccount} BudgetIDStr={BudgetList.bean.BudgetIDStr} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {BudgetList.bean.Name}</strong>
                    </ModalConfirm>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalviewdoc} updateModal={setModalviewdoc}>
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentViewer
                                    list={docs}

                                />
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}